import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { DashboardServices } from "../../Apis/AuthApiServices";
import { loadingServices, setServices } from "../Slice/UserServicesSlice";
import { resolveIsAgentixRxDefault, resolveIsAgentixRxEnabled } from "../../utils/AIPrescription/agentixRxAccess";

function withAgentixRxFlags(servicesData: any) {
  if (!servicesData || typeof servicesData !== "object" || Array.isArray(servicesData)) {
    return servicesData;
  }
  return {
    ...servicesData,
    isAgentixRxEnabled: resolveIsAgentixRxEnabled(servicesData),
    isAgentixRxDefault: resolveIsAgentixRxDefault(servicesData),
  };
}

function* onLoadServicesAsync({ payload }: any) {
  let doctorId: any = localStorage.getItem("doctorId");
  let userId: any = localStorage.getItem("LoginUserID");
  const data = {
    doctorId: doctorId,
    userId: userId,
    onBehalfDoctorId: payload.onBehalfDoctorId,
    selectedClinicId: payload.selectedClinicId,
  };

  try {
    const result: AxiosResponse = yield DashboardServices(data);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setServices({
          ServicesData: withAgentixRxFlags(result?.data?.response[0]),
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setServices({
          ServicesData: [],
          error: true,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error: any) {
    yield put(
      setServices({
        ServicesData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadServices() {
  yield takeLatest(loadingServices.type, onLoadServicesAsync);
}

const UserServicesSaga = [fork(onLoadServices)];
export default UserServicesSaga;
